export default __webpack_public_path__ + "static/media/filledArrow.acb4cca6.svg";